export const TransactionStatus = {
  WAITING_FUND: 'WAITING FOR FUNDS',
  UNPAID: 'PAYMENT PENDING',
  SETTLED: 'SUCCESSFUL',
  CANCELLED: 'CANCELLED',
  ON_HOLD_BENEFICIARY: 'AWAITING RECIPIENT SIGNUP',
  ON_HOLD: 'WAITING FOR AIRLINE CONFIRMATION',
  DECLINED: 'FAILED',
  APPROVAL_REJECTED: 'DECLINED',
  WAITING_FOR_PAYER: 'REQUESTED',
  PENDING_FINANCE_APPROVAL: 'PENDING',
  REJECTED: 'REJECTED',
  AWAITING_PAYMENT: 'WAITING FOR TRANSFER',
  OVER_DUE: 'OVERDUE',
  PENDING: 'PENDING',
  AWAITING_APPROVAL: 'WAITING FOR APPROVAL',
};
